<template>
  <el-dialog
    :visible.sync="addServiceDialog"
    width="50%"
    title="设备"
    :close-on-click-modal="false"
  >
    <el-form :inline="true">
        <el-form-item>
        <el-date-picker
      v-model="times"
      type="daterange"
      range-separator="至"
       value-format="yyyy-MM-dd"
      start-placeholder="开始日期"
      end-placeholder="结束日期">
    </el-date-picker>
      </el-form-item>
         
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
      </el-form-item>
    </el-form>
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #openType="{ row }">
        {{ getNameByValue(openDoorType, row.open_type) }}
      </template>
      <template #url="{ row }">
        <div class="" v-if="row.picUrlArray">
            <el-link :href="v" target="_blank" v-for="(v, i) in row.picUrlArray"
            :key="i">快照图片{{i}}<i class="el-icon-view el-icon--right"></i></el-link>
        </div>
      </template>
    </auto-table>

    <span slot="footer" class="dialog-footer">
      <el-button @click="addServiceDialog = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { openDoorType } from "@/views/deviceManage/components/dict";
export default {
  data() {
    return {
      openDoorType,
      DataList: [],
      Option: [
        { name: "开门人员", value: "name" },
        { name: "开门方式", value: "openType", type: "custom" },
        // { name: "开门快照", value: "url", type: "custom", col_type: "expand" },
         { name: "时间", value: "create_time" },
      ],
      Total: 0,
      status: 1,
      role: "coach",
      addServiceDialog: false,
      device: {},
      times:[]
    };
  },
  methods: {
    open(row) {
      this.device = row;
      this.addServiceDialog = true;
      this.getList(1);
    },
    //获取列表
    getList(v) {
      let page = v || 1;
      let url = "/device/openRecord/queryManagerListPage";
      let params = {
        currentPage: page,
        pageSize: 10,
        device_sn: this.device.device_id,
      };
      if(this.times && this.times.length > 0){
        params.start_time = this.times[0] + ' 00:00:00'
        params.end_time = this.times[1] + ' 23:59:59'
      }

      this.$get(url, params).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>